export const questions = [
  {
    question: "Why do you want to adopt a dog?",
    options: [
      "companionship",
      "emotional support",
      "outdoor adventures",
      "other",
    ],
    label: "reason",
  },
  {
    question: "What is your home like?",
    options: ["apartment", "home", "town home", "condo"],
    label: "home",
  },
  {
    question: "What’s your ideal dog personality?",
    options: ["social", "adventurous", "independent", "protective"],
    label: "personality",
  },
  {
    question: "What is your shedding tolerance?",
    options: [
      "Below average",
      "hypoallergenic",
      "average",
      "above average",
      "No preference",
    ],
    label: "shedding",
  },
  {
    question: "What age range of dog are you looking for?",
    options: ["puppy", "Adult", "Senior"],
    range: "activity",
  },
  {
    question: "What is your activity level?",
    options: ["Somewhat active", "active", "very active"],
    label: "activity",
  },
  {
    question: "What size dog do you prefer?",
    options: ["small", "medium size", "large"],
    label: "size",
  },
  {
    question: "How much are you willing to spend a month for upkeep care?",
    options: ["less than $100", "$100 - $300", "No limit"],
    label: "upkeep",
  },
];
